/* eslint-disable */
import axios from 'axios'
import {
	Message,
	MessageBox
} from 'element-ui'
import router from '@/router';
import Qs from 'qs'
import baseUrl from "./baseUrl.js"
// 请求地址
axios.defaults.baseURL = baseUrl
export function msg(message, type) {
	this.$message({
		message: message,
		type: type
	});
}
axios.interceptors.response.use(res => {
	return res;
}, error => {
	console.log(error, 'error')
	if (!error.response) {
		MessageBox.alert('为了您的账号安全，请重新登录系统', '登录已过期', {
			type: 'error',
			confirmButtonText: '我知道了',
			showClose: false,
			center: true
		}).then(() => {
			// 清除缓存
			localStorage.clear()
			// 跳转到登录页
			router.push('/')
		})
		return Promise.reject(error)
	}
	//token失效返回401处理
	if (error.response.code == 401) {
		//刷新token
		console.log('hahahahaah')
	}
	return Promise.reject(error.response.data) // 返回错误信息
})
// 需要登录进入的页面
const TokenPage = [
	'auth/logout',
	'auth/profile',
	'auth/update',
	'base/buy/live',
	'base/buy/video',
	'base/buy/ebook',
	'base/integral/document',
	'base/integral/ebook',
	'base/upload',
	'chatroom/join',
	'chatroom/send',
	'course_live_broadcast_preview',
	'course_live_broadcast_preview/appointment',
	'course_live_broadcast_preview/comment/add',
	'course_live_broadcast_preview/code/check',
	'course_live_broadcast_preview/password/check',
	'course_live_broadcast_preview/appoint/check',
	'ebook/detail',
	'group_course_live_broadcast_preview',
	'group_course_live_broadcast_preview/group_success',
	'group_course_live_broadcast_preview/appointment',
	'group_video_lesson/comment/add',
	'group_video_lesson/code/check',
	'pay/cancel',
	'message/query',
	'message/read',
	'message/unread',
	'user/wallet',
	'user/wallet/prepay',
	'user/integral',
	'user/invite/qrcode',
	'user/invite/info',
	'user/sign/info',
	'user/sign/task',
	'user/sign',
	'user/sign/task/report',
	'user/learning/info',
	'user/learning/rank',
	'user/learning/report',
	'user/collect/add',
	'user/collect',
	'user/collect/cancel',
	'user/personal/task',
	'user/personal/task/create',
	'user/personal/task/delete',
	'user/personal/task/today',
	'user/order/single',
	'user/order/group',
	'user/order/integral',
	'user/report_complete_course',
	'user/feedback',
	'user/purchased',
	'user/learning_rate',
	'user/report_learning_rate',
	'user/study_card',
	'video_lesson',
	'video_lesson/comment/add',
	'video_lesson/code/check',
	'video_lesson/password/check',
	'video_lesson/appoint/check',
	'vip_recharge/prepay'
]
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, params) {
	// 请求的接口是否需要登录
	if (TokenPage.indexOf(url) != -1) {
		if (!localStorage.getItem('userInfo_')) {
			this.$confirm('您还没有登录，请先登录！', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				closeOnPressEscape: false,
				closeOnClickModal: false,
				showClose: false,
				type: 'warning',
				center: true
			}).then(() => {
				this.$router.push('/?login=false')
			}).catch(() => {
				this.$router.push('/?login=false')
			});
		}
	}
	return new Promise((resolve, reject) => {
		axios.get(url, {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					'Authorization': JSON.parse(localStorage.getItem('userInfo_')) ? 'Bearer ' + JSON.parse(
						localStorage.getItem('userInfo_')).token : ''
				},
				params
			}).then(response => {
				//response&&resolve(response.data);
				if (response) {
					if (response.data.code == 0) {
						this.$message({
							message: response.data.msg,
							type: 'error'
						});
						return false
					} else if (response.data) {
						resolve(response.data);
					}
				} else {
					resolve(response)
				}
			})
			.catch(err => {
				console.log(err, 'pppppp')
				reject(err)
			})
	})
}
/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
let this_ = this
export function post(url, data = {}, params = {}) {
	// 请求的接口是否需要登录
	if (TokenPage.indexOf(url) != -1) {
		if (!localStorage.getItem('userInfo_')) {
			this.$confirm('您还没有登录，请先登录！', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				closeOnPressEscape: false,
				closeOnClickModal: false,
				showClose: false,
				type: 'warning',
				center: true
			}).then(() => {
				this.$router.push('/')
			}).catch(() => {
				this.$router.push('/')
			});
		}
	}
	return new Promise((resolve, reject) => {
		axios.post(url, Qs.stringify(data), {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					'Authorization': JSON.parse(localStorage.getItem('userInfo_')) ? 'Bearer ' + JSON.parse(
						localStorage.getItem('userInfo_')).token : '',
				},
				params
			})
			.then(response => {
				if (response) {
					if (response.data) {
						if (response.data.code == 500) {
							this.$message({
								message: response.data.msg,
								type: 'error'
							});
						} else if (response.data.code == 0) {
							this.$message({
								message: response.data.msg,
								type: 'error'
							});
							return false
						} else {
							resolve(response.data);
						}
					}
				} else {
					resolve(response)
				}
			}, (err) => {
				if (err.code == '401') {
					MessageBox.alert('为了您的账号安全，请重新登录系统', '登录已过期', {
						type: 'error',
						confirmButtonText: '我知道了',
						showClose: false,
						center: true
					}).then(() => {
						// 清除缓存
						localStorage.clear()
						// 跳转到登录页
						router.push('/')
					})
				}
				reject(err)

			}).catch(cat => {
				console.log(cat)
			})
	})
}
// 上传文件
export function upLoad(url, data = {}, params = {}) {
	return new Promise((resolve, reject) => {
		axios.post(url, data, {
				headers: {
					"Content-Type": "multipart/form-data",
					'Authorization': JSON.parse(localStorage.getItem('userInfo_')) ? 'Bearer ' + JSON.parse(
						localStorage.getItem('userInfo_')).token : '',
				}
			})
			.then(
				response => {
					resolve(response.data);
				},
				err => {
					reject(err);
				}
			);
	});
}
// 下载文件
export function downFile(url, params) {
	return new Promise((resolve, reject) => {
		axios(url, {
			headers: {
				"Content-Type": "multipart/form-data",
				'Authorization': JSON.parse(localStorage.getItem('userInfo_')) ? 'Bearer ' + JSON.parse(
					localStorage.getItem('userInfo_')).token : '',
			},
			responseType: 'blob', //重要代码
		}).then(res => {
			const url = window.URL.createObjectURL(new Blob([res.data]));
			const link = document.createElement('a');
			link.href = url;
			let fileName = "使用说明文档" //保存到本地的文件名称
			link.setAttribute('download', fileName);
			document.body.appendChild(link);
			link.click();
		})
	})
}

// 状态码
function serveCode(code) {
	switch (code) {
		// 无权限访问,请尝试重新登录
		case 401:
			MessageBox.alert('为了您的账号安全，请重新登录系统', '登录已过期', {
				type: 'error',
				confirmButtonText: '我知道了',
				showClose: false,
				center: true
			}).then(() => {
				// 清除缓存(token/uid)
				localStorage.clear()
				// 跳转到登录页
				router.push('/home')
			})
			break;
	}
}

// 时间戳转化
export function formatDate(str, isCum) {
	if (isCum) {
		var n = parseInt(str);
	} else {
		var n = parseInt(str) * 1000;
	}
	var D = new Date(n);
	var year = D.getFullYear(); //四位数年份			
	var month = D.getMonth() + 1; //月份(0-11),0为一月份
	month = month < 10 ? ('0' + month) : month;
	var day = D.getDate(); //月的某一天(1-31)
	day = day < 10 ? ('0' + day) : day;
	var hours = D.getHours(); //小时(0-23)
	hours = hours < 10 ? ('0' + hours) : hours;
	var minutes = D.getMinutes(); //分钟(0-59)
	minutes = minutes < 10 ? ('0' + minutes) : minutes;
	var seconds = D.getSeconds(); //秒(0-59)
	seconds = seconds < 10 ? ('0' + seconds) : seconds;
	var now_time = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
	return now_time;
}


// 倒计时
export function CountDown(time) {
	var date = new Date();
	var now = date.getTime();
	//设置截止时间  
	var str = time
	var endDate = new Date(str);
	var end = endDate.getTime();

	//时间差  
	var leftTime = end - now;
	//定义变量 d,h,m,s保存倒计时的时间  
	var d, h, m, s;
	if (leftTime >= 0) {
		d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
		h = Math.floor(leftTime / 1000 / 60 / 60 % 24);
		m = Math.floor(leftTime / 1000 / 60 % 60);
		s = Math.floor(leftTime / 1000 % 60);
	}
	console.log(d, 'dddd')
	const restTime = {
		day: d,
		hour: h,
		min: m,
		seconds: s
	}
	return restTime
	//将倒计时赋值到div中  
	// document.getElementById("_d").innerHTML = d+"天";  
	// document.getElementById("_h").innerHTML = h+"时";  
	// document.getElementById("_m").innerHTML = m+"分";  
	// document.getElementById("_s").innerHTML = s+"秒";  
	//递归每秒调用countTime方法，显示动态时间效果  
	// setTimeout(countTime,1000);
}


// WEBPACK FOOTER //
// ./src/util/request.js